import { render, staticRenderFns } from "./AdminMonitors.vue?vue&type=template&id=5ed0ea8d&scoped=true&"
import script from "./AdminMonitors.vue?vue&type=script&lang=js&"
export * from "./AdminMonitors.vue?vue&type=script&lang=js&"
import style0 from "./AdminMonitors.vue?vue&type=style&index=0&id=5ed0ea8d&prod&lang=css&"
import style1 from "./AdminMonitors.vue?vue&type=style&index=1&id=5ed0ea8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed0ea8d",
  null
  
)

export default component.exports